import React, { useState, useEffect } from "react";
import axios from "axios";
import Dashboardnavbarcopy from "../../../layout/Dashboardnavbar";
import { BASE_URL_PREBID, FRONTEND_URL } from "../../../config/axios";
import { useNavigate, useParams } from "react-router-dom";
import { UpdateProjectAmount } from "../../../components/Modals/Allmodals";
import { AddStages, StagesManagement } from "../../../components/Modals/Addstages";
import { ToastContainer, toast } from "react-toastify";
import { formatCurrencyIndian } from "../../../components/custom";

const Projectbyclient = () => {
    let { id } = useParams();


    const [allClientsData, setAllClientsData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [search1, setSearch1] = useState("")
    const [search2, setSearch2] = useState("")
    const [search3, setSearch3] = useState("")
    const [search4, setSearch4] = useState("")
    const [buffer, setBuffering] = useState(true); //buffering logic


    const getJobappdata = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL_PREBID}/project/projectbyclient/${id}/`);
            setAllClientsData(res.data);
            console.log(allClientsData);

            setFilteredData(res.data);

        } catch (err) {
            //toast Logic
            if (err.response) {
                const errorData = err.response.data;

                if (typeof errorData.error === 'string') {
                    // Single error message
                    toast.error(`Error: ${errorData.error}`);
                } else if (typeof errorData === 'object' && errorData !== null) {
                    // Multiple error messages
                    Object.entries(errorData).forEach(([field, messages]) => {
                        messages.forEach(message => toast.error(`"${field}": ${message}`));
                    });
                } else {
                    toast.error('Error:- Failed to Process!');
                }
            } else {
                toast.error('Error processing your request.');
            }
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        // handleSearch();
        getJobappdata();
    }, []);

    //! ***********************Navigate to next page *******************************// 
    const navigate = useNavigate()

    const currentUrl = window.location.href;


    const urlParts = currentUrl.split('/');


    const baseUrl = "/" + urlParts[3] + `/invoicebyproject`;

    const allproject = (pr_code) => {
        navigate(baseUrl + `/${pr_code}/`)
    }
    //! ***********************Navigate to next page *******************************// 

    return (
        <>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <Dashboardnavbarcopy url="Dashboard" name={"Project By Client"} />

            {/*  ********** Client Details **********  */}
            <div className="content-tabs">

              
                <div className="attendance-box">

                    <div className="datagrid-container">
                        <div className="custom-table-background height-73vh">
                            <div className="table-heading-flex">
                                <div className="repo-heading font-size-heading font-weight500">
                                </div>
                            </div>
                            <div className="table-box">
                                <table className="custom-table">
                                    <thead className="table-heading">
                                        <tr className="custom-table-head-trr font-size-subheading font-weight600">
                                            <th className="align-left font-size-text font-weight600">Sr no.</th>
                                            <th className="align-center font-size-text font-weight600">Project Name</th>
                                            <th className="align-center font-size-text font-weight600">Client Name</th>
                                            <th className="align-center font-size-text font-weight600">Total Amount</th>
                                            <th className="align-center font-size-text font-weight600">GST</th>
                                            <th className="align-center font-size-text font-weight600">Amount without GST</th>
                                            <th className="align-center font-size-text font-weight600">Invoice</th>
                                            <th className="align-center font-size-text font-weight600">Billing Amount</th>
                                            <th className="align-center font-size-text font-weight600">Balance to Bill</th> <th className="align-center font-size-text font-weight600">Billing Percentage</th>
                                            <th className="align-center font-size-text font-weight600">Received Amount</th>
                                            <th className="align-center font-size-text font-weight600">Received Percentage</th>
                                            <th className="align-center font-size-text font-weight600">View</th>
                                            <th className="align-center font-size-text font-weight600">Edit</th>
                                            <th className="align-center font-size-text font-weight600">Add Payment Stages</th>


                                            {/* <th className="align-center font-size-text font-weight400"></th>
                                        <th className="align-center font-size-text font-weight400"></th> */}
                                        </tr>

                                    </thead>
                                    {buffer ? <div className="spinner"></div> : //buffering logic

                                        <tbody>

                                            {filteredData
                                                .sort((a, b) => a.client_name.localeCompare(b.client_name, 'en', { ignorePunctuation: true }))

                                                .map((i, index) => (
                                                    <React.Fragment key={index}>
                                                        <tr className="tr-border-bottom">
                                                            <td colSpan="8"></td>
                                                        </tr>
                                                        <tr className="custom-table-head-td">
                                                            <td className="align-left font-size-text font-weight400">{index + 1}</td>
                                                            <td className="align-center font-size-text font-weight400">{i.project_short_name} </td>
                                                            <td className="align-center font-size-text font-weight400">{i.client_name}<br></br>{i.contact_number}</td>
                                                            <td className="align-center font-size-text font-weight400">{formatCurrencyIndian(i.woamount)}</td>
                                                            <td className="align-center font-size-text font-weight400">{formatCurrencyIndian(i.gst_amount)}</td>
                                                            <td className="align-center font-size-text font-weight400">{formatCurrencyIndian(i.without_gst_amount)}</td>
                                                            <td className="align-center font-size-text font-weight400">{i.invoice_count}</td>
                                                            <td className="align-center font-size-text font-weight400">{formatCurrencyIndian(i.billing_amount)}</td>
                                                            <td className="align-center font-size-text font-weight400">{formatCurrencyIndian(i.woamount - i.received_amount)}</td>
                                                            <td className="align-center font-size-text font-weight400">{i.billing_percentage}</td>
                                                            <td className="align-center font-size-text font-weight400">{formatCurrencyIndian(i.received_amount)}</td>
                                                            <td className="align-center font-size-text font-weight400">{i.received_percentage}</td>
                                                            <td className="align-center font-size-text font-weight400">
                                                                <button className="models-button model-add" onClick={(e) => allproject(i.pr_code)}>
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="30"
                                                                        height="30"
                                                                        viewBox="0 0 30 30"
                                                                        fill="none">

                                                                        <circle cx="15" cy="15" r="15" fill="#F6F7F9" />
                                                                        <path
                                                                            d="M23.8913 14.5437C22.1966 11.2372 18.8416 9 15 9C11.1584 9 7.80249 11.2388 6.10873 14.5441C6.03725 14.6855 6 14.8417 6 15.0002C6 15.1586 6.03725 15.3148 6.10873 15.4563C7.80342 18.7628 11.1584 21 15 21C18.8416 21 22.1975 18.7612 23.8913 15.4559C23.9628 15.3145 24 15.1583 24 14.9998C24 14.8414 23.9628 14.6852 23.8913 14.5437ZM15 19.5C14.11 19.5 13.24 19.2361 12.4999 18.7416C11.7599 18.2471 11.1831 17.5443 10.8425 16.7221C10.5019 15.8998 10.4128 14.995 10.5865 14.1221C10.7601 13.2492 11.1887 12.4474 11.818 11.818C12.4474 11.1887 13.2492 10.7601 14.1221 10.5865C14.995 10.4128 15.8998 10.5019 16.7221 10.8425C17.5443 11.1831 18.2472 11.7599 18.7416 12.4999C19.2361 13.24 19.5 14.11 19.5 15C19.5003 15.591 19.3841 16.1763 19.1581 16.7224C18.932 17.2685 18.6005 17.7647 18.1826 18.1826C17.7647 18.6005 17.2685 18.932 16.7224 19.158C16.1763 19.3841 15.591 19.5003 15 19.5ZM15 12C14.7322 12.0037 14.4662 12.0436 14.2091 12.1184C14.421 12.4065 14.5227 12.7609 14.4957 13.1175C14.4688 13.4741 14.3149 13.8092 14.062 14.062C13.8092 14.3149 13.4741 14.4688 13.1175 14.4957C12.7609 14.5227 12.4065 14.421 12.1184 14.2091C11.9544 14.8133 11.984 15.4538 12.2031 16.0403C12.4221 16.6269 12.8196 17.1299 13.3396 17.4787C13.8595 17.8275 14.4758 18.0045 15.1016 17.9847C15.7274 17.965 16.3312 17.7495 16.8281 17.3685C17.325 16.9876 17.6899 16.4604 17.8715 15.8612C18.0531 15.2621 18.0422 14.621 17.8404 14.0283C17.6386 13.4356 17.256 12.9211 16.7465 12.5573C16.2369 12.1934 15.6261 11.9985 15 12Z"
                                                                            fill="#2576BC"
                                                                        />

                                                                    </svg>
                                                                </button>
                                                            </td>
                                                            <td className="align-center font-size-text font-weight400">
                                                                <UpdateProjectAmount id={i.pr_code} />
                                                            </td>

                                                            <td className="align-center font-size-text font-weight400">
                                                                <StagesManagement id={i.pr_code} />


                                                            </td>



                                                        </tr>
                                                    </React.Fragment>
                                                ))}
                                        </tbody>
                                    }
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Projectbyclient
